// extracted by mini-css-extract-plugin
module.exports = {"container":"design-module--container--26xTw","svg":"design-module--svg--8VrZN"};